/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { ServerDataSource } from 'ng2-smart-table';


@Injectable({
  providedIn: 'root'   
})
export class HttpSellerService {

// private apiUrl = 'https://dev-api.shukhee.com';
  constructor(private http: HttpClient) {}

  getServerDataSource(uri: string): DataSource {
    return new ServerDataSource(this.http,
      {
        endPoint: uri,
        totalKey: 'totalCount',
        dataKey: 'items',
        pagerPageKey: 'pageNumber',
        pagerLimitKey: 'pageSize',
        filterFieldKey: 'filterBy#field#',
        sortFieldKey: 'sortBy',
        sortDirKey: 'orderBy',
      });
  }

  get(endpoint: string, options?): Observable<any> {
    return this.http.get(`${endpoint}`, options);
  }
//  getAuth(endpoint: string, options?): Observable<any> {
//     return this.http.get(`${this.apiAuthUrl}/${endpoint}`, options);
//   }
  post(endpoint: string, data, options?): Observable<any> {
    return this.http.post(`${endpoint}`, data, options);
  }

  put(endpoint: string, data, options?): Observable<any> {
    return this.http.put(`${endpoint}`, data, options);
  }

  delete(endpoint: string, options?): Observable<any> {
    return this.http.delete(`${endpoint}`, options);
  }

  directGet(endpoint: string, options?): Observable<any> {
    return this.http.get(`${endpoint}`, options);
  }

  directPost(endpoint: string, data, options?): Observable<any> {
    return this.http.post(`${endpoint}`, data, options);
  }
  

  directPut(endpoint: string, data, options?): Observable<any> {
    return this.http.put(`${endpoint}`, data, options);
  }

  directDelete(endpoint: string, options?): Observable<any> {
    return this.http.delete(`${endpoint}`, options);
  }

  mailPost(data,options?){
    return this.http.post(`${environment.mailApiUrl}`,data, options);
  }
  patch(endpoint: string, data, options?): Observable<any> {
    return this.http.patch(`${endpoint}`, data, options);
  }
}
